import i18n from 'i18n/config'
import store from 'store'
import { BaseResponse } from 'types/Response'
import { auth } from 'utils/firebase'

const endpoint = process.env.REACT_APP_API_ENDPOINT || ''

export const postRequest = async (
  formData: FormData,
  headers: HeadersInit = {},
): Promise<BaseResponse> => {
  const {
    settings: { deviceId },
  } = store.getState()

  const token = await auth.currentUser?.getIdToken()

  const result = await fetch(`${endpoint}/requests`, {
    method: 'POST',
    body: formData,
    headers: {
      'X-Device-Id': deviceId,
      ...(token && {
        Authorization: `Bearer ${token}`,
      }),
      ...headers,
    },
  })

  if (!result.ok) {
    throw new Error(`${i18n.t('error.api')}: ${result.status}`)
  }

  return result.json()
}

export const getRequestById = async (
  requestId: number,
  headers: HeadersInit = {},
): Promise<BaseResponse> => {
  const {
    settings: { deviceId },
  } = store.getState()

  const token = await auth.currentUser?.getIdToken()

  const result = await fetch(`${endpoint}/requests/${requestId}`, {
    method: 'GET',
    headers: {
      'X-Device-Id': deviceId,
      ...(token && {
        Authorization: `Bearer ${token}`,
      }),
      ...headers,
    },
  })

  if (!result.ok) {
    throw new Error(`${i18n.t('error.api')}: ${result.status}`)
  }

  return result.json()
}

export const getRequests = async (
  sourceType: 'image' | 'text',
  page: number = 1,
  take: number = 12,
  headers: HeadersInit = {},
): Promise<BaseResponse[]> => {
  const {
    settings: { deviceId },
  } = store.getState()

  const token = await auth.currentUser?.getIdToken()

  const domain = token ? 'requests/user/all' : 'requests'

  const params = new URLSearchParams({
    source_type: sourceType,
    page: page.toString(),
    take: take.toString(),
  }).toString()

  const result = await fetch(`${endpoint}/${domain}?${params}`, {
    method: 'GET',
    headers: {
      'X-Device-Id': deviceId,
      ...(token && {
        Authorization: `Bearer ${token}`,
      }),
      ...headers,
    },
  })

  if (!result.ok) {
    throw new Error(`${i18n.t('error.api')}: ${result.status}`)
  }

  return result.json()
}

export const linkDeviceToUser = async (): Promise<boolean> => {
  const {
    settings: { deviceId },
  } = store.getState()

  const token = await auth.currentUser?.getIdToken()

  if (!token) return false

  const result = await fetch(`${endpoint}/login`, {
    method: 'POST',
    headers: {
      'X-Device-Id': deviceId,
      Authorization: `Bearer ${token}`,
    },
  })

  if (!result.ok) throw new Error(`${i18n.t('error.api')}: ${result.status}`)

  return true
}
